/**
 * @Author: v_jppjpeng
 * @Date: 2023-3-14 10:26:48
 * @Explain: 项目管理（项目、绑定角色、权限）
 */

export default {
  'BUSINESS.MANAGE.CREATE.TITLE': '创建新项目',
  'BUSINESS.MANAGE.CREATE.TITLE.DESC': '创建项目信息',
  'BUSINESS.MANAGE.CREATE.TIPS1': '如果项目已经在Playernetwork注册，请',
  'BUSINESS.MANAGE.CREATE.TIPS2': '点击这里',
  'BUSINESS.MANAGE.CREATE.TIPS3': '输入项目ID，快速创建项目。',
  'BUSINESS.MANAGE.CREATE.FORM.NAMEEN': '项目英文名',
  'BUSINESS.MANAGE.CREATE.FORM.NAMEZH': '项目中文名',
  'BUSINESS.MANAGE.CREATE.FORM.GAME.NAME': '游戏名称',
  'BUSINESS.MANAGE.CREATE.FORM.DEVELOPER': '研发方',
  'BUSINESS.MANAGE.CREATE.FORM.PUBLISHING.METHOD': '发行方式',
  'BUSINESS.MANAGE.CREATE.FORM.GAME.CONTACT': '项目接口人',
  'BUSINESS.MANAGE.CREATE.FORM.REMARKS': '备注',
  'BUSINESS.MANAGE.CREATE.FORM.COMPANY': '公司/工作室',

  'BUSINESS.MANAGE.CREATE.PLACEHOLDER.NAMEEN': '请输入项目英文名称',
  'BUSINESS.MANAGE.CREATE.PLACEHOLDER.NAMEZH': '请输入项目中文名称',
  'BUSINESS.MANAGE.CREATE.PLACEHOLDER.GAME.NAME': '输入游戏名称',
  'BUSINESS.MANAGE.CREATE.PLACEHOLDER.DEVELOPER': '请选择研发方',
  'BUSINESS.MANAGE.CREATE.PLACEHOLDER.USERNAME': '请输入用户名',
  'BUSINESS.MANAGE.CREATE.PLACEHOLDER.PUBLISHING.METHOD': '请选择发行方式',
  'BUSINESS.MANAGE.CREATE.PLACEHOLDER.GAME.CONTACT': '请输入项目接口人',
  'BUSINESS.MANAGE.CREATE.PLACEHOLDER.REMARKS': '请输入内容',
  'BUSINESS.MANAGE.CREATE.PLACEHOLDER.COMPANY': '输入公司/游戏工作室名称',

  'BUSINESS.MANAGE.CREATE.DEVELOP.OPTIONS01': '自研工作室',
  'BUSINESS.MANAGE.CREATE.DEVELOP.OPTIONS02': '国内Studio',
  'BUSINESS.MANAGE.CREATE.DEVELOP.OPTIONS03': '海外Studio',
  'BUSINESS.MANAGE.CREATE.DEVELOP.OPTIONS04': '其他',

  'BUSINESS.MANAGE.CREATE.PUBLISHMODE.OPTIONS01': 'IEGG发行',
  'BUSINESS.MANAGE.CREATE.PUBLISHMODE.OPTIONS02': '授权外部发行',
  'BUSINESS.MANAGE.CREATE.PUBLISHMODE.OPTIONS03': 'IEG国内发行线',
  'BUSINESS.MANAGE.CREATE.PUBLISHMODE.OPTIONS04': '其他',

  'BUSINESS.MANAGE.JOIN.MAIN.TITLE': 'PNT项目快速创建',
  'BUSINESS.MANAGE.JOIN.TITLE': '加入已有项目',
  'BUSINESS.MANAGE.JOIN.TITLE.TIPS':
    '适用于已在SmartLink或Player Network中创建过项目并生成ID的项目',
  'BUSINESS.MANAGE.PROJECT.CREATED': '项目已创建，请联系owner邀请您加入项目',
  'BUSINESS.MANAGE.JOIN.PROJECT.NOEXIST': 'ID不存在',
  'BUSINESS.MANAGE.JOIN.PROJECT.TOAST.NOEXIST': 'Project ID 不存在',
  'BUSINESS.MANAGE.JOIN.PROJECTID': '请提供项目ID',
  'BUSINESS.MANAGE.JOIN.PLACEHOLDER1': '在PNT内注册的项目ID',
  'BUSINESS.MANAGE.JOIN.PLACEHOLDER': '请输入项目ID',
  'BUSINESS.MANAGE.JOIN.PROJECTINFO': '项目详情',
  'BUSINESS.MANAGE.JOIN.PROJECTID.TIPS': '您可以从项目的创建者那里获得ID。',
  'BUSINESS.MANAGE.JOIN.PROJECT.ID': 'ID',
  'BUSINESS.MANAGE.JOIN.PROJECT.NAME': '名称',
  'BUSINESS.MANAGE.JOIN.PROJECT.APLLYROLE': '申请项目角色',
  'BUSINESS.MANAGE.JOIN.PROJECT.OWNER': '超级管理员',
  'BUSINESS.MANAGE.JOIN.PROJECT.OWNER.TIPS':
    '作为项目的主要联系人，每个项目只允许有一个该类型的角色用户，该用户可以访问项目的所有功能。',
  'BUSINESS.MANAGE.JOIN.PROJECT.ADMIN': '普通管理员',
  'BUSINESS.MANAGE.JOIN.PROJECT.ADMIN.TIPS': '提供完全访问项目的权限',
  'BUSINESS.MANAGE.JOIN.PROJECT.MANAGER': '高级运营',
  'BUSINESS.MANAGE.JOIN.PROJECT.MANAGER.TIPS':
    '允许用户创建电子邮件模板，创建和发送活动，导入联系人。此用户类型不能邀请新用户。',
  'BUSINESS.MANAGE.JOIN.PROJECT.AUTHOR': '普通运营',
  'BUSINESS.MANAGE.JOIN.PROJECT.AUTHOR.TIPS':
    '允许用户创建、编辑、删除活动和电子邮件模板，但不能发送活动。',
  'BUSINESS.MANAGE.JOIN.PROJECT.ROLE.TOAST.NOEXIST': '项目角色必选',
  'BUSINESS.MANAGE.JOIN.PROJECT.TOAST.SUCCESS': '操作成功',
  'BUSINESS.MANAGE.JOIN.PROJECT.ALREADY.EXISTS':
    '您已在项目内，如需修改权限，请联系项目创建人处理。',

  'BUSINESS.MANAGE.PERMISSION.TITLE': '权限列表',

  'BUSINESS.MANAGE.PERMISSION.TABS.MYPERMISSION': '我的权限',
  'BUSINESS.MANAGE.PERMISSION.TABS.ALLPERMISSION': '所有权限',
  'BUSINESS.MANAGE.PERMISSION.TABS.MYPENDINGAPPROVAL': '待我审批',

  'BUSINESS.MANAGE.PERMISSION.PLACEHOLDER.PROJECT': '选择项目',

  'BUSINESS.MANAGE.PERMISSION.TABLE.PROJECTNAME': '项目名',
  'BUSINESS.MANAGE.PERMISSION.TABLE.PROJECTID': '项目 ID',
  'BUSINESS.MANAGE.PERMISSION.TABLE.ROLE': '角色',
  'BUSINESS.MANAGE.PERMISSION.TABLE.USERNAME': '用户名',
  'BUSINESS.MANAGE.PERMISSION.TABLE.STATUS': '状态',
  'BUSINESS.MANAGE.PERMISSION.TABLE.APPLICANT': '申请人',
  'BUSINESS.MANAGE.PERMISSION.TABLE.ACTIVATION.TIME': '激活时间',
  'BUSINESS.MANAGE.PERMISSION.TABLE.APPLICATION.TIME': '申请时间',
  'BUSINESS.MANAGE.PERMISSION.TABLE.APPROVALBY': '审批人',
  'BUSINESS.MANAGE.PERMISSION.TABLE.APPROVALSTATUS': '审批状态',

  'BUSINESS.MANAGE.PERMISSION.TABLE.BUTTON.REMOVE': '移除',
  'BUSINESS.MANAGE.PERMISSION.TABLE.BUTTON.REAPPLY': '重新申请',
  'BUSINESS.MANAGE.PERMISSION.TABLE.BUTTON.AGREE': '通过',
  'BUSINESS.MANAGE.PERMISSION.TABLE.BUTTON.REJECT': '拒绝',

  'BUSINESS.MANAGE.PERMISSION.TABLE.APPROVAL.DIALOG.AGREE.TITLE': '确认同意么?',
  'BUSINESS.MANAGE.PERMISSION.TABLE.APPROVAL.DIALOG.REJECT.TITLE':
    '确认拒绝么?',

  'BUSINESS.MANAGE.PERMISSION.TABLE.MYPERMISSION.DIALOG.REMOVE.TITLE':
    '确认删除么?',

  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.REMOVE': '移除',
  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.REJECT': '拒绝',
  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.REAPPLY': '重新申请',
  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.AGREE': '同意',

  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.REMOVE.SUCCESS': '移除成功!',
  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.REMOVE.FAIL': '移除失败!',
  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.REJECT.SUCCESS': '拒绝成功!',
  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.REJECT.FAIL': '拒绝失败!',
  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.APPLY.SUCCESS':
    '申请已提交，等待批准',
  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.APPROVALED.SUCCESS': '审批成功',
  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.APPLY.SUCCESS.WAIT':
    '等待Player Network审批',
  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.APPLY.FAIL': '申请提交失败!',

  'BUSINESS.MANAGE.PERMISSION.TABLE.STATUS.APPLYING': '申请中',
  'BUSINESS.MANAGE.PERMISSION.TABLE.STATUS.APPROVALED': '已通过',
  'BUSINESS.MANAGE.PERMISSION.TABLE.STATUS.AVAILABLE': '可用的',
  'BUSINESS.MANAGE.PERMISSION.TABLE.STATUS.REJECTED': '已拒绝',
  'BUSINESS.MANAGE.PERMISSION.TABLE.STATUS.RE_APPLYING': '重新申请中',

  // 我的项目 - 列表
  'BUSINESS.MANAGE.PROJECT.LIST.TITLE': '项目列表',
  'BUSINESS.MANAGE.PROJECT.LIST.AVAILABLE': '可用',
  'BUSINESS.MANAGE.PROJECT.LIST.PENDING': '待定',
  'BUSINESS.MANAGE.PROJECT.LIST.PENDING.TIPS.TITLE': '待批说明',
  'BUSINESS.MANAGE.PROJECT.LIST.PENDING.TIPS1':
    'SmartLink系统管理员将在1个工作日内完成审核。',
  'BUSINESS.MANAGE.PROJECT.LIST.PENDING.TIPS2':
    '如果您有任何问题，请联系 <a href="mailto:{mail}">{mail}</a>',
  'BUSINESS.MANAGE.PROJECT.LIST.PROJECT.INFO': '项目信息',
  'BUSINESS.MANAGE.PROJECT.LIST.MY.ROLE': '我的角色',
  'BUSINESS.MANAGE.PROJECT.LIST.JOINING.TIME': '加入时间',
  'BUSINESS.MANAGE.PROJECT.LIST.APPLICATION.TIME': '申请时间',
  'BUSINESS.MANAGE.PROJECT.LIST.APPLICATION.TIME.TIPS': '项目创建时间',
  'BUSINESS.MANAGE.PROJECT.LIST.APPLICATION.STATUS': '申请状态',
  'BUSINESS.MANAGE.PROJECT.LIST.PASSED': '通过',
  'BUSINESS.MANAGE.PROJECT.LIST.REJECTED': '拒绝',
  'BUSINESS.MANAGE.PROJECT.LIST.PENDING.APPROVAL': '待批准',
  'BUSINESS.MANAGE.PROJECT.LIST.REAPPLY': '重新申请',
  'BUSINESS.MANAGE.PROJECT.LIST.INVITER': '邀请人',
  'BUSINESS.MANAGE.PROJECT.LIST.YOURSELF': '你自己',
  'BUSINESS.MANAGE.PROJECT.LIST.CURRENT': '当前',
  'BUSINESS.MANAGE.PROJECT.LIST.CURRENT.TIPS': '当前选择的项目',
  'BUSINESS.MANAGE.PROJECT.LIST.ENTER': '进入',
  'BUSINESS.MANAGE.PROJECT.DEMO': '体验项目',
};
